import { Site } from '@envato/foundation-types'
import * as React from 'react'

import { IEnhancedLocation } from '../../../../common/reducers/reactRouterLocation'
import { getConfigBySite } from '../../../../config/sites'
import { IItem } from '../../../../typings/searchResults'
import UsDollarsNoticeContainer from '../../../components/usDollarsNotice/usDollarsNoticeContainer'
import VideoControllsContainer from '../../../components/video/videoControllsContainer'
import FeatureContainer from '../../../containers/feature'
import V0SearchResults from '../../../v0/pages/search/result/searchResultBody'
import SearchResultsBody from '../../search/result/searchResultBody'

import * as styles from './featurePageContent.module.css'

interface IProps {
  featuredItems: IItem[]
  location: IEnhancedLocation
  currentSite: Site
}

const FeaturePageContent = ({
  featuredItems,
  location,
  currentSite
}: IProps) => {
  const firstItem = featuredItems.slice(0, 1)
  const restItems = featuredItems.slice(1)
  const firstItemViewType = getConfigBySite(
    currentSite,
    'ui.featured_hero_item_viewtype'
  )
  const heroSectionClassName =
    currentSite === Site.photodune
      ? styles.photoHeroSection
      : styles.defaultHeroSection
  const shouldShowVideoControlls = currentSite === Site.videohive
  return (
    <div>
      <div className={styles.heroSectionBackground}>
        <div className={heroSectionClassName}>
          <FeatureContainer name="!v0-featured-page">
            <SearchResultsBody
              location={location}
              matches={firstItem}
              viewType={firstItemViewType}
            />
          </FeatureContainer>
          <FeatureContainer name="v0-featured-page">
            <V0SearchResults
              location={location}
              matches={firstItem}
              viewType={firstItemViewType}
            />
          </FeatureContainer>
        </div>
      </div>
      <div className={styles.gridWidthSectionBackground}>
        <div className={styles.gridWidthSection}>
          <div className={styles.titleSection}>
            <h2 className={styles.subtitle}>
              Items featured in the last 6 months
            </h2>
            <div className={styles.controls}>
              <div className={styles.gstMsg}>
                <UsDollarsNoticeContainer />
              </div>
              {shouldShowVideoControlls && (
                <div className={styles.videoContrls}>
                  <VideoControllsContainer />
                </div>
              )}
            </div>
          </div>
          <FeatureContainer name="!v0-featured-page">
            <SearchResultsBody
              location={location}
              matches={restItems}
              viewType="grid"
            />
          </FeatureContainer>
          <FeatureContainer name="v0-featured-page">
            <V0SearchResults
              location={location}
              matches={restItems}
              viewType="grid"
            />
          </FeatureContainer>
        </div>
      </div>
    </div>
  )
}

export default FeaturePageContent
